export const Sticky = () => ({input: false, handles: [], isConnectable: false});
export const B = (isConnectable) => ({input: true, handles: [], isConnectable});
export const V = (isConnectable) => ({input: false, handles: ["V"], isConnectable});
export const BV = (isConnectable) => ({input: true, handles: ["V"], isConnectable});
export const BVR = (isConnectable) => ({input: true, handles: ["V", "R"], isConnectable});
export const BVAR = (isConnectable) => ({input: true, handles: ["V", "A", "R"], isConnectable});
export const BP = (isConnectable) => ({input: true, handles: ["P"], isConnectable});

